"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TriangleDown: function() {
        return TriangleDown;
    },
    TriangleUp: function() {
        return TriangleUp;
    },
    default: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _react = require("react");
var _reacttable = require("@tanstack/react-table");
var _matchsorterutils = require("@tanstack/match-sorter-utils");
var _core = require("../../core");
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
var _icons = require("../../assets/icons");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n  border: 1px solid #d3d3d3;\n  border-radius: 4px;\n  border-spacing: 0;\n  border-collapse: separate;\n  overflow: hidden;\n\n  thead th {\n    height: 48px;\n  }\n  tbody {\n    tr td {\n      border-top: none;\n    }\n    tr {\n      height: 60px;\n    }\n    tr:nth-of-type(even) {\n      background: #f9f9f9;\n    }\n    tr:hover {\n      background: #ededed;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal_loose([
        "\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 9px solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal_loose([
        "\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 9px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTable = (0, _styled.default)(_core.Table)(_templateObject());
var TriangleUp = (0, _styled.default)("div")(_templateObject1(), function(props) {
    return props.color ? props.color : "#fff";
});
var TriangleDown = (0, _styled.default)("div")(_templateObject2(), function(props) {
    return props.color ? props.color : "#fff";
});
var mockedData = [
    {
        age: 22,
        partnerName: "AMEX",
        loungeUID: "12345",
        country: "UK",
        airport: "Heathrow",
        terminal: "T5",
        invite: true,
        signedIn: true
    },
    {
        age: 2,
        partnerName: "SCODA",
        loungeUID: "133234",
        country: "USA",
        airport: "JFK",
        terminal: "T2",
        invite: true,
        signedIn: false
    }
];
var TableX = function() {
    var _useState = (0, _react.useState)(""), globalFilter = _useState[0], setGlobalFilter = _useState[1];
    var columnHelper = (0, _reacttable.createColumnHelper)();
    var _useState1 = (0, _react.useState)({}), rowSelection = _useState1[0], setRowSelection = _useState1[1];
    var _useState2 = (0, _react.useState)([
        {
            id: "partnerName",
            desc: true
        }
    ]), sorting = _useState2[0], setSorting = _useState2[1];
    var columns = (0, _react.useMemo)(function() {
        return [
            columnHelper.display({
                header: " ",
                cell: function(param) {
                    var row = param.row;
                    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Checkbox, {
                        pl: 6,
                        checked: row.getIsSelected(),
                        disabled: !row.getCanSelect(),
                        indeterminate: row.getIsSomeSelected(),
                        onChange: row.getToggleSelectedHandler()
                    });
                }
            }),
            columnHelper.accessor("partnerName", {
                header: "Partner name"
            }),
            columnHelper.accessor("loungeUID", {
                header: "Lounge UID"
            }),
            columnHelper.accessor("country", {
                header: "Country"
            }),
            columnHelper.accessor("airport", {
                header: "Airport"
            }),
            columnHelper.accessor("terminal", {
                header: "Terminal"
            }),
            columnHelper.accessor("invite", {
                header: "Invite",
                cell: function(props) {
                    return props.getValue() === true ? /*#__PURE__*/ (0, _jsxruntime.jsx)(_jsxruntime.Fragment, {
                        children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                            align: "center",
                            gap: 8,
                            children: [
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.GreenCircle, {}),
                                " Sent"
                            ]
                        })
                    }) : /*#__PURE__*/ (0, _jsxruntime.jsx)(_jsxruntime.Fragment, {
                        children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                            align: "center",
                            gap: 8,
                            children: [
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.RedCircle, {}),
                                " No"
                            ]
                        })
                    });
                }
            }),
            columnHelper.accessor("signedIn", {
                header: "Signed in",
                cell: function(props) {
                    return props.getValue() === true ? /*#__PURE__*/ (0, _jsxruntime.jsx)(_jsxruntime.Fragment, {
                        children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                            align: "center",
                            gap: 8,
                            children: [
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.GreenCircle, {}),
                                " Yes"
                            ]
                        })
                    }) : /*#__PURE__*/ (0, _jsxruntime.jsx)(_jsxruntime.Fragment, {
                        children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                            align: "center",
                            gap: 8,
                            children: [
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.RedCircle, {}),
                                " No"
                            ]
                        })
                    });
                }
            })
        ];
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var data = (0, _react.useMemo)(function() {
        return globalFilter === "" ? mockedData : mockedData.filter(function(item) {
            return item.partnerName.toLowerCase().includes(globalFilter.toLowerCase()) || item.loungeUID.toLowerCase().includes(globalFilter.toLowerCase());
        });
    }, [
        globalFilter
    ]);
    var fuzzyFilter = function(row, columnId, value, addMeta) {
        // Rank the item
        var itemRank = (0, _matchsorterutils.rankItem)(row.getValue(columnId), value);
        // Store the itemRank info
        addMeta({
            itemRank: itemRank
        });
        // Return if the item should be filtered in/out
        return itemRank.passed;
    };
    var table = (0, _reacttable.useReactTable)({
        data: data,
        columns: columns,
        state: {
            sorting: sorting,
            globalFilter: globalFilter,
            rowSelection: rowSelection
        },
        enableSortingRemoval: false,
        onGlobalFilterChange: setGlobalFilter,
        onRowSelectionChange: setRowSelection,
        globalFilterFn: fuzzyFilter,
        onSortingChange: setSorting,
        getCoreRowModel: (0, _reacttable.getCoreRowModel)(),
        getSortedRowModel: (0, _reacttable.getSortedRowModel)()
    });
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Stack, {
        gap: 24,
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                direction: "row",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                        align: "center",
                        gap: 32,
                        children: [
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Checkbox, {
                                pl: 16,
                                checked: table.getIsAllRowsSelected(),
                                indeterminate: table.getIsSomeRowsSelected(),
                                onChange: table.getToggleAllRowsSelectedHandler()
                            }),
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Button, {
                                disabled: Object.keys(rowSelection).length === 0,
                                children: "Send invite"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Input, {
                        styles: {
                            input: {
                                borderRadius: 4
                            }
                        },
                        style: {
                            minWidth: 239
                        },
                        placeholder: "Search by partner or by UID",
                        value: globalFilter != null ? globalFilter : "",
                        onChange: function(value) {
                            return setGlobalFilter(String(value.target.value));
                        },
                        rightSection: /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.Magglass, {
                                size: "0.5rem",
                                style: {
                                    display: "block",
                                    opacity: 0.5
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsxs)(StyledTable, {
                children: [
                    /*#__PURE__*/ (0, _jsxruntime.jsx)("thead", {
                        style: {
                            background: "#0C8599"
                        },
                        children: table.getHeaderGroups().map(function(headerGroup) {
                            return /*#__PURE__*/ (0, _jsxruntime.jsx)("tr", {
                                children: headerGroup.headers.map(function(header) /*#__PURE__*/ {
                                    var _header_column_getIsSorted;
                                    return (0, _jsxruntime.jsx)("th", {
                                        colSpan: header.colSpan,
                                        style: {
                                            color: "#FFFFFF",
                                            fontWeight: 400,
                                            userSelect: "none"
                                        },
                                        children: header.isPlaceholder ? null : /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
                                            sx: {
                                                cursor: header.column.getCanSort() ? "pointer" : "auto"
                                            },
                                            onClick: header.column.getToggleSortingHandler(),
                                            children: [
                                                (0, _reacttable.flexRender)(header.column.columnDef.header, header.getContext()),
                                                /*#__PURE__*/ (0, _jsxruntime.jsx)("span", {
                                                    style: {
                                                        paddingLeft: 8
                                                    },
                                                    children: (_header_column_getIsSorted = ({
                                                        asc: /*#__PURE__*/ (0, _jsxruntime.jsx)(TriangleUp, {}),
                                                        desc: /*#__PURE__*/ (0, _jsxruntime.jsx)(TriangleDown, {})
                                                    })[header.column.getIsSorted()]) != null ? _header_column_getIsSorted : null
                                                })
                                            ]
                                        })
                                    }, header.id);
                                })
                            }, headerGroup.id);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxruntime.jsx)("tbody", {
                        children: table.getRowModel().rows.slice(0, 10).map(function(row) {
                            return /*#__PURE__*/ (0, _jsxruntime.jsx)("tr", {
                                children: row.getVisibleCells().map(function(cell) {
                                    return /*#__PURE__*/ (0, _jsxruntime.jsx)("td", {
                                        children: (0, _reacttable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                    }, cell.id);
                                })
                            }, row.id);
                        })
                    })
                ]
            })
        ]
    });
};
var _default = TableX;
